import { render, staticRenderFns } from "./ElePayFail.vue?vue&type=template&id=145854e0"
import script from "./ElePayFail.vue?vue&type=script&lang=js"
export * from "./ElePayFail.vue?vue&type=script&lang=js"
import style0 from "./ElePayFail.vue?vue&type=style&index=0&id=145854e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports